import { z } from "zod";

import { fetchWithError } from "@nens/react-query-utils";
import { parseJwt } from "@nens/shared-utils";

import { AUTH_API_BASE_URL } from "../constants";

const tokenResponseSchema = z.object({
  access: z.string(),
  // refresh: z.string() // We don't use this
});

const tokenPayloadSchema = z.object({
  // Only fields that we use
  exp: z.number(), // Expires
  user_id: z.number(),
  username: z.string(),
  email: z.string(),
  tenant: z.number(),
  tenant_name: z.string(),
  scope: z.string(),
});

type TokenPayload = z.infer<typeof tokenPayloadSchema>;

export type Scope = "viewer" | "admin" | "manager" | "reviewer" | "superuser";

export interface FetchTokenResponse {
  tenantId: number;
  accessToken: string;
  payload: TokenPayload;
}

export const fetchToken = async (tenantId: number): Promise<FetchTokenResponse> => {
  const tokenResponse = await fetchWithError(`${AUTH_API_BASE_URL}/token/`, {
    method: "POST",
    body: JSON.stringify({ tenant: tenantId }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const accessToken = tokenResponseSchema.parse(tokenResponse).access;
  const payloadJson = parseJwt(accessToken);
  const payload = tokenPayloadSchema.parse(payloadJson);

  if (payload.tenant !== tenantId) {
    throw new Error(`Requested token for tenant ${tenantId}, received one for ${payload.tenant}.`);
  }

  return {
    tenantId,
    accessToken,
    payload,
  };
};
